/*
 * @Author: pengyong
 * @Date: 2020-11-11 22:19:48
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-16 22:34:55
 * @Description: 登录注册接口定义
 * @FilePath: /exhibit/src/api/login.js
 */
import { BASE_URL, LOGIN_URL } from './config';
import axios from "@/utils/axios.js";

// 获取图形验证码
export function getCaptcha(params) {
    return axios.$get(`${LOGIN_URL}/v1/captcha`, params);
}
// 注册
export function register(params) {
    return axios.$post(`${LOGIN_URL}/v1/register`, params);
}
// 登录
export function login(params) {
    return axios.$post(`${LOGIN_URL}/v1/login`, params); 
}
// 手机验证码登录
export function smslogin(params) {
    return axios.$post(`${LOGIN_URL}/v1/smslogin`, params);
}
// 邮箱登录
export function maillogin(params) {
    return axios.$post(`${LOGIN_URL}/v1/maillogin`, params);
}



// WEBPACK FOOTER //
// ./src/api/login.js